/* THIS FILE SHOULD BE REMOVED ONCE WE HAVE GOTTEN RID OF LOCAL TENANTS */
import { Injectable } from '@angular/core';
import { User } from 'oidc-client-ts';
import { Observable, of } from 'rxjs';
import { InterfaceOf } from '../object-utils';
import { AuthService, IxUser } from './auth.service';

const dummyUser: IxUser = {
  email: 'default-dev-user@ix-systemuser',
  displayName: 'Offline User',
  id: '-1',
  roles: '',
};

const oidcUser = {} as User;
@Injectable()
export class AuthLocalService implements InterfaceOf<AuthService> {
  user$: Observable<IxUser> = of(dummyUser);
  oidcUser$ = of({ displayName: 'LOCAL-TENANT-DISPLAY-NAME', email: 'default-user@akso.io' } as IxUser);

  signinCallback = () => Promise.resolve(oidcUser);
  getAccessToken = () => of('LOCAL-TENANT-TOKEN');
  hasTenantAdminRole = () => of(true);
  redirectLogin = () => Promise.resolve();
  logout = () => Promise.resolve();
  getUserState = () => of(true);
}
